module.exports = __webpack_public_path__ + "static/img/LatrellMitchell.5150f2e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/LatrellMitchell.jpg
// module id = huks
// module chunks = 0